import moment from "moment";

export interface MyMoment {
  formatWithLocale(
    date: Date | string,
    format: string,
    locale?: string
  ): string;
  formatEpochMillis(
    epochMillis: number | string | undefined | null,
    format?: string,
    defaultValue?: string
  ): string;
}

const MomentUtil: MyMoment = {
  ...moment,
  formatWithLocale: function (
    date: Date | string,
    format: string,
    locale?: string
  ): string {
    const m = moment(date);
    if (locale) {
      m.locale(locale);
    }
    return m.format(format);
  },
  formatEpochMillis: function(
    epochMillis: number | string | undefined | null,
    format: string = "DD-MM-YYYY",
    defaultValue: string = "-"
  ): string {
    if (epochMillis === undefined || epochMillis === null) {
      return defaultValue;
    }
    
    // Handle both string and number types for epoch
    const milliseconds = typeof epochMillis === 'string' ? parseInt(epochMillis, 10) : epochMillis;
    
    // Check if the timestamp is valid
    if (isNaN(milliseconds) || milliseconds <= 0) {
      return defaultValue;
    }
    
    return moment(milliseconds).format(format);
  },
};

export default MomentUtil;
